/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: Type your file description
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2023-02-02 10:05:25
 * @LastEditTime: 2023-03-10 13:50:30
 * @FilePath: /client-h5-v2/src/lang/package/hi.js
 */
'use strict'

Object.defineProperty(exports, '__esModule', { value: true })

const English = {
  name: 'hi',
  btn: {
    ok: 'ठीक',
    confirm: 'पुष्टि करें',
    yes: 'हां',
    no: 'नहीं',
    toagent: 'चैट के साथ लाइव एजेंट',
    exitAgent: 'एजेंट',
    accept: 'मैंने स्वीकार किया',
    noThinks: 'जी नहीं, धन्यवाद',
    submit: 'सबमिट',
    picture: 'छवि',
    file: 'फ़ाइल',
    cancel: 'रद्द करें',
    connecting: 'कनेक्शन कर रहा है'
  },
  temp: {
    dialog: {
      emptyMsgTips: 'कृपया भेजे से पहले सामग्री भरें!',
      send: 'सबमिट',
      sendTips: 'भेजने के लिए प्रविष्ट कुंजी दबाएँ'
    },
    header: {
      login: 'login',
      logout: 'logout',
      logoutLoadingText: 'logout...',
      themeChange: 'Switch Theme',
      bgChange: 'Change Background'
    },
    slider: {
      clickPause: 'प्लेबैक को ठहराने के लिए क्लिक करें',
      clickPlay: 'स्वचालित रूप से बजाने के लिए क्लिक करें',
      clickLook: 'देखने के लिए क्लिक करें',
      oneClickSkinning: 'स्किनिंग'
    },
    answer: {
      // AnswerCommonFaq.vue
      yes: 'हां',
      no: 'नहीं',
      confirmClear: 'क्या आप सबसे पसंदीदा साफ करना चाहते हैं?',
      confirmCancel: 'क्या आप सुनिश्चित है कि आप निर्देशित करना चाहते हैं?',
      clear: 'खाली',
      cancel: 'पसंदीदा',
      change: 'अगला पृष्ठ',
      // AnswerMultiIntention.vue
      more: 'अधिक',
      // AnswerMultiSteps.vue
      resolve: 'हल हो गया',
      // AnswerRichtext.vue
      fullscreen: 'पूरा स्क्रीन',
      important: 'जरूरी'
    },
    common: {
      relatedQuestion: 'संबंधित प्रश्न',
      fileSizeLimit: 'छवि सीमा से बढ़ता है',
      clickStore: 'पसंदीदा के लिए क्लिक करें',
      clickCancelStore: 'अद्यतन करने के लिए क्लिक करें',
      storeQuestion: 'पसंदीदा प्रश्न',
      prevStep: 'पछिला चरण',
      nextStep: 'अगला चरण',
      note: 'टिप्पणी',
      buy: 'अभी खरीदें',
      copy: 'नकल',
      copySuccess: 'सफलता की नक़ल करें',
      from: 'से',
      off: 'बंद'
    }
  },
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: '',
      deprecationWarning: 'Deprecated usages detected, please refer to the el-pagination documentation for more details'
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'],
      filterPlaceholder: 'Enter keyword',
      noCheckedFormat: '{total} items',
      hasCheckedFormat: '{checked}/{total} checked'
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      title: 'Back'
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }
  },
  AnswerWarrantyMoli: {
    warranty: 'वारंटी मैं',
    extended: 'विस्तारित वारंटी',
    expiredIn: 'में समाप्त हो गया',
    expired: 'समय सीमा समाप्त'
  },
  AnswerProductInfo: {
    Learn: 'और अधिक जानें'
  },
  FromCallBack: {
    Call: 'कॉल बैक मैसेज',
    Time: 'समय की उलटी गिनती:',
    Sorry: 'क्षमा करें, कृपया खाली फ़ील्ड भरें.',
    Name: 'नाम',
    NameErrorTips: 'Proszę zostaw swoje imię',
    Country: 'देश',
    Please: 'कृपया उस देश का चयन करें जिसे आपने अपना उत्पाद खरीदा था',
    Email: 'ईमेल',
    EmailErrorTips: 'Please leave your email address',
    emailMessage: 'यदि आपके पास पहले एजेंटों के साथ संपर्क है, तो हम आपको उस ईमेल पते को छोड़ने का सुझाव देते हैं.',
    PhoneNumber: 'फ़ोन नंबर',
    PhoneNumberValidTips: '11 अंक आवश्यक',
    AvailableTime: 'Available time',
    AvailableTimeRequireTips: 'Please select your appropriate answering time. Please note you will recieve a phone call from "no caller ID" number',
    Describe: 'कृपया अपनी समस्या बताएं',
    Procudt: 'उत्पाद नमूना',
    IMEI: 'आईएमईआई',
    submit: 'सबमिट',
    note: '¿Nos has contactado anteriormente?',
    require: 'jest wymagane'
  },
  Prompt: {
    thank: 'आपकी प्रतिक्रिया के लिए आपका धन्यवाद।',
    surveyTimeText: 'मूल्यांकन समाप्त हो गया है और आपको फिर से सेवा देने के लिए तत्पर हैं।',
    connecting: 'कनेक्टिंग',
    Succeded: 'आरक्षण सफल हुआ',
    Failed: 'आरक्षण विफल',
    timeOut: 'क्षमा करें, आपके आवेदन का समय समाप्त हो गया है। यदि आपको पुनः सबमिट करने की आवश्यकता है, तो कृपया पुन: आवेदन करने के लिए MOLI पर लौटें। विसंगति के लिए क्षमा करें।',
    startOver: 'प्रारंभ करें',
    close: 'बंद करे',
    Retry: 'पुन: प्रयास करें',
    THANKS: 'जी नहीं, धन्यवाद',
    ratevirtual: 'वर्चुअल एजेंट को रेट करें'
  }
}

exports['default'] = English
// # sourceMappingURL=en.js.map
